import React, { Component } from 'react'

import Grid from '@material-ui/core/Grid';
import { startMap } from './GisScript';

export default class GisContainer extends Component {
    componentDidMount() {
        // create map        
        startMap();        
    }

    render() {
        return (
            <Grid xs={12} id="gis" item></Grid>
        )
    }
}